/* eslint-disable react/jsx-pascal-case */
import { Row, Col, Checkbox, Form, Input, MultipleSelectorV2, Select } from "../../ui/ot";
import React, { useEffect, } from "react";
import { usePermission } from "../controller/PermissionController";
import { useMenu } from "../controller/menu_controller";
const PageManagementForm = ({
    propsForm = null,
    formReloadCount = 0,
    onFormFinish = () => { },
    editcard,
}) => {
    const [form] = Form.useForm();
    const setFormValuesOtherThings = (formValues) => {
        //做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
        };
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues);
        } else {
            form.setFieldsValue(newFormValues);
        }
    };
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
        getPermissionChildrenData({
            classify_structure_id: 5,
            // classify_structure_type_id: 0,
        });
        getMenuData({});
        if (editcard) {
        }
    };
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        });
    };
    const onValuesChange = () => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldsValue();
        } else {
            formValues = form.getFieldsValue();
        }
        // setFormValuesOtherThings(formValues);
    };
    const getLanguageLabel = (language_culture_code) => {
        let label = {
            "zh-tw": "中文",
            en: "英文",
        };
        return label[language_culture_code];
    };
    const getLanguageName = ({ language_culture_code, obj_language_data }) => {
        let label = {
            "zh-tw": "中文",
            en: "英文",
        };
        let nameValue = obj_language_data.find((element) => {
            return element?.language_culture_code === language_culture_code;
        })?.language_culture_value;
        return nameValue || ""
    };
    const getAnyFormValue = (name, count) => {
        let formValues = null;
        formValues = form.getFieldValue(name);
        return formValues;
    };
    const setFieldValue = (name, value) => {

        form.setValue(name, value);
    };
    const { getPermissionChildrenData, permissionChildrenData } = usePermission(
        {
            onBefore: () => { },
            onFinish: () => { },
        }
    );
    const { getMenuData, MenuData } = useMenu({
        onBefore: () => { },
        onFinish: () => { },
    });

    const selectOption = [
        {
            label: '森林',
            value: 'url(/1.jpg)'
        },
        {
            label: '科技實驗',
            value: 'url(/2.jpg)'
        },
        {
            label: '銀河',
            value: 'url(/3.jpg)'
        },
        {
            label: '燈火',
            value: 'url(/4.jpg)'
        },
        {
            label: '水波',
            value: 'url(/5.jpg)'
        }
    ]
    useEffect(() => {
        setDataInitialization();
    }, []);
    useEffect(() => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldsValue();
        } else {
            formValues = form.getFieldsValue();
        }
    }, [formReloadCount]);

    return (
        <Row
            gutter={[10, 20]}
            justify="space-around"
            style={{ padding: "3vmin" }}
        >
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    // layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                    initialValues={{
                        name_language_data: [
                            {
                                language_culture_code: "zh-tw",
                                language_culture_value: "",
                            },
                        ],
                        permission_page_data: [],
                    }}
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                labelCol={6}
                                wrapperCol={18}
                                label={"page_id"}
                                hidden={true}
                                name={"page_id"}
                            >
                                <Input></Input>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Row>
                                <Col span={24}>
                                    <Form.List name={"name_language_data"}>
                                        {(fields, { add, remove }) => (
                                            <Row>
                                                {fields.map((field) => (
                                                    <Col span={24}>
                                                        <Row>
                                                            <Col span={24}>
                                                                <Form.Item
                                                                    hidden={
                                                                        true
                                                                    }
                                                                    name={[
                                                                        field.name,
                                                                        "language_culture_code",
                                                                    ]}
                                                                >
                                                                    <Input />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={24}>
                                                                <Form.Item
                                                                    labelCol={6}
                                                                    wrapperCol={
                                                                        18
                                                                    }
                                                                    label={`頁面${getLanguageLabel(
                                                                        field?.language_culture_code
                                                                    )}名稱`}
                                                                    name={[
                                                                        field.name,
                                                                        "language_culture_value",
                                                                    ]}
                                                                    rules={[
                                                                        {
                                                                            required:
                                                                                field?.language_culture_code ===
                                                                                "zh-tw",
                                                                            message:
                                                                                "此為必填",
                                                                        },
                                                                    ]}
                                                                >
                                                                    <Input />
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                ))}

                                            </Row>
                                        )}
                                    </Form.List>
                                </Col>
                                <Col span={24}>
                                    <Form.Item
                                        label={"頁面選單"}
                                        name={"permission_page_data"}
                                        labelCol={6}
                                        wrapperCol={18}
                                    >
                                        <MultipleSelectorV2
                                            options={permissionChildrenData.map(
                                                (value) => {
                                                    return {
                                                        label: value?.name,
                                                        value: value?.permission_id,
                                                    };
                                                }
                                            )}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item
                                        label={"呈現選單分類"}
                                        name={"page_menu_data"}
                                        labelCol={6}
                                        wrapperCol={18}
                                    >
                                        <MultipleSelectorV2
                                            options={MenuData.map(
                                                (value) => {
                                                    return {
                                                        label: getLanguageName({ language_culture_code: "zh-tw", obj_language_data: value?.name_language_data || [] }),
                                                        value: value?.menu_id,
                                                    };
                                                }
                                            )}
                                        />
                                    </Form.Item>
                                </Col>

                                <Col span={24}>
                                    <Form.Item
                                        label={"背景圖設定"}
                                        name={"property_json.backgroundImage"}
                                        labelCol={6}
                                        wrapperCol={18}
                                    >
                                        <Select
                                            options={
                                                selectOption &&
                                                selectOption.map(
                                                    (selectOptionItem, selectOptionIndex) => {
                                                        return {
                                                            ...selectOptionItem,
                                                            value: selectOptionItem.value,
                                                            label: selectOptionItem.label,
                                                        };
                                                    }
                                                )
                                            }
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
    );
};

export default PageManagementForm;
